















































import TeacherDashboadMenu from './TeacherDashboadMenu.vue';
import { Vue, Component, Mixins } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { UserAuthDTO } from '../../../src_server/entity/dto/UserAuthDTO';
import { buildingData } from '../../../src_server/entity/master/buildingData';
import { LessonsService } from '../../biz/remote/LessonsService';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { dayjs } from '../../../src_server/common/momentExtends';
import EmergencyMessageDialog from '../../components/messages/EmergencyMessageDialog.vue';
import { MessageDialog } from '../../utils/MessageDialog';
import TeacherDashboardRow from './TeacherDashboardRow.vue';
import TransferDialog from '../components/TransferDialog.vue';
import { routeHelper } from '../../utils/routeHelper';
class LessonByStudent {
  student_user_id = '';
  student_nickname = '';
  lessonsDto: LessonDTO[] = [];
}
@Component({
  components: {
    TeacherDashboadMenu,
    EmergencyMessageDialog,
    TeacherDashboardRow,
    TransferDialog,
  },
})
export default class TeacherDashboardPage extends Vue {
  private lessons: any[] = [];
  private lessonsDto: LessonDTO[] = [];

  private get reservationCount() {
    // 予約依頼数
    return this.lessonsDto.filter((dto) => dto.lessons.reservation_state === LessonStates.RESERVATION).length;
  }

  private get model(): LessonByStudent[] {
    // 予約依頼中を除外
    const filterd = this.lessonsDto.filter((dto) => dto.lessons.reservation_state !== LessonStates.RESERVATION);
    // 日付でソート
    const sorted = filterd.sort((a, b) => {
      return dayjs(a.lessons?.start_dt).diff(dayjs(b.lessons?.start_dt));
    });
    // ユーザーごとにまとめつつ、直近のレッスンをマークする
    const grouped = sorted.reduce((pre: LessonByStudent[], cur: LessonDTO): LessonByStudent[] => {
      // 登録済みならマージ
      const found = pre.find((item) => item.student_user_id === cur.student?.user_id);
      if (found) {
        found.lessonsDto.push(cur);
      } else {
        const newData = new LessonByStudent();
        newData.student_user_id = cur.student?.user_id || '';
        newData.student_nickname = cur.student?.nickname || '';
        newData.lessonsDto.push(cur);
        pre.push(newData);
      }
      return pre;
    }, []);
    const result = grouped.map((g) => {
      const recent = g.lessonsDto.find((dto) => {
        console.log(dto.lessons.start_dt);
        return dayjs(dto.lessons.start_dt).diff(dayjs(), 'date') > 0;
      });
      // 直近のレッスンをマーク
      if (recent) {
        recent.isRecent = true;
      }
      return g;
    });

    return result;
  }

  async created() {
    console.log('created');
    const user = Session.get<UserAuthDTO>('USER');
    if (!user || !user.user_id) return;
    // Line通知の初期登録表示に利用
    const lessonService = new LessonsService();
    const res = await lessonService.getLessonsByTeacher(Session.getSessionUserId());
    this.lessonsDto = res.data;
  }

  showRequest() {
    routeHelper(this, 'LessonReservationCommitPage');
  }

  async message(lesson: LessonDTO) {
    const dialog: EmergencyMessageDialog = this.$refs['emergency_message_dialog'] as EmergencyMessageDialog;
    await dialog.show(lesson.lessons.class_id!);
  }

  gotoDailyReport(dto: LessonDTO) {
    if (!dto.lessons.class_id) {
      MessageDialog.systemError('レッスンID', '日報への遷移時', dto.lessons.class_id).then();
      return;
    }
    routeHelper(this, 'TeacherDailyReportPage', { class_id: dto.lessons.class_id.toString() });
  }

  async transfer(row: LessonDTO) {
    const dialog: TransferDialog = this.$refs['taransfer_dialog'] as TransferDialog;
    const dt = row.lessons?.start_dt || new Date();
    await dialog.show(dt, row);
  }
}
